export const AcceptedMimeTypes: string[] = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
  'application/vnd.ms-powerpoint', // .ppt
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'text/csv', // .csv
  'image/png', // .png
  'image/jpeg', // .jpg
  'application/pdf', // .pdf
  'application/zip', // .zip
  'application/x-zip-compressed', // .zip
];
